import React from 'react';
import { Grid, Typography, styled } from '@nextiva/next-ui-components';
import PropTypes from 'prop-types';

import xClose from 'icons/xClose.svg';

import styles from './Drawer.scss';

const StyledTitle = styled(Typography)`
  color: ${({ theme }) => theme.palette.secondary.contrastText};
  line-height: 2rem;
`;

const DrawerHeader = ({ title, toggleDrawer, TitleComponent }) => {
  return (
    <div className={styles.drawerHeader}>
      <Grid className={styles.root} container spacing={2} alignItems="center">
        <Grid
          container
          item
          xs={12}
          data-testid="PlatformAdminUI-UsersLink-Drawer-Header"
        >
          <StyledTitle variant="h5"> {title} </StyledTitle>
          {TitleComponent && <TitleComponent />}
          <img
            alt="close"
            src={xClose}
            className={styles.xClose}
            onClick={toggleDrawer}
            role="presentation"
            data-testid="PlatformAdminUI-UsersLink-Drawer-CloseIcon"
          />
        </Grid>
      </Grid>
    </div>
  );
};

DrawerHeader.propTypes = {
  TitleComponent: PropTypes.oneOfType([PropTypes.bool, PropTypes.elementType]),
  title: PropTypes.string,
  toggleDrawer: PropTypes.func,
};

export default DrawerHeader;
